<div class="root" *transloco="let t; read:'permit.additionalInformation'">
    <div class="root__question-text">{{ t("heading") }}</div>

    <div class="root__info-text" *ngIf="(workplaceDetails$ | async)?.additionalInformationRequired; else optionalInformation">
        {{ t("requiredInfo") }}
    </div>

    <ng-template #optionalInformation>
        <div class="root__info-text">{{ t("optionalInfo") }}</div>
    </ng-template>

    <form [formGroup]="form">
        <ha-input class="root__input" formControlName="permitAdditionalInformation" [label]="t('input')" [maxlength]="100"></ha-input>
    </form>

    <div class="root__actions">
        <button class="root__actions__back" type="button" (click)="goBack()">{{ t("back") }}</button>
        <button class="root__actions__continue" type="button" (click)="continue()" [class.root__actions__continue--disabled]="form.invalid">
            {{ t("next") }}
        </button>
    </div>
</div>
